module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(_vm.label) ? _c('label', {
    class: _vm.labelClasses
  }, [(_vm.required) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.inputOrientationClasses
  }, [_vm._t("default"), _vm._v(" "), (_vm.state == 'error') ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.help))]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b5d218c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/formbox.vue
// module id = 700
// module chunks = 85